// ================================================================
// NUTRIOP QUIZ RESULTS CART HANDLER
// File: quiz-results-cart.js
// Add to: assets/ folder in your Shopify theme
// Purpose: Handle add to cart functionality for quiz results
// ================================================================

(function() {
  'use strict';
  
  // Helper function to generate dynamic monthly discount code
  function generateDiscountCode() {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const currentMonth = months[new Date().getMonth()];
    return `LONGEVITY25${currentMonth}`;
  }
  
  // Updated product catalog with correct variant IDs
  const productCatalog = {
    'Pure NMN Sublingual Powder': 40320249200700,
    'Bio-Enhanced Resveratrol Plus': 44890815398199,
    'ERGO-Supreme': 40233004597308,
    'Bio-Enhanced Berberine HCL': 32533764472892,
    'Pure Spermidine': 39732496891964,
    'Life ULTRA': 47624047722807,
    'Pure NMN Capsules': 32604804677692,
    'Pure Resveratrol + Quercetin': 46999245291831,
    'Bio-Enhanced Resveratrol with Quercetin': 46999245291831, // Same as above
    'Pterostilbene Extreme': 31356443557948,
    'NAD PLUS': 31810861203516,
    'Complete Longevity Stack': 'bundle'
  };
  
  // Check if we're on a permalink
  function isPermalink() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has('quiz_id') || urlParams.has('result_id') || urlParams.has('results');
  }
  
  // Main add to cart function
  window.quizAddToCart = function(productName, variantId, isAlternative = false) {
    // Prevent default behavior
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    // If variantId is 0 or not found, try to get it from catalog
    if (!variantId || variantId === 0) {
      variantId = productCatalog[productName];
      if (!variantId) {
        alert('Product not found: ' + productName);
        return false;
      }
    }
    
    const button = event?.target;
    const originalText = button?.textContent;
    const discountCode = generateDiscountCode();
    
    // Update button state
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding to cart...';
    }
    
    // Track in Klaviyo
    if (typeof klaviyo !== 'undefined') {
      try {
        klaviyo.push(['track', 'Quiz Add to Cart', {
          'Product Name': productName,
          'Product Type': isAlternative ? 'alternative' : 'primary',
          'Source': isPermalink() ? 'email_permalink' : 'instant_results',
          'Variant ID': variantId,
          'Discount Code': discountCode,
          'Timestamp': new Date().toISOString()
        }]);
      } catch (error) {
        console.error('Klaviyo tracking error:', error);
      }
    }
    
    // Handle bundle products
    if (variantId === 'bundle') {
      const bundleProducts = [
        productCatalog['Pure NMN Sublingual Powder'],
        productCatalog['Bio-Enhanced Resveratrol Plus'],
        productCatalog['Pure Spermidine']
      ];
      
      Promise.all(bundleProducts.map(id => 
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({ id: id, quantity: 1 })
        })
      ))
      .then(() => {
        window.location.href = `/discount/${discountCode}?redirect=/cart`;
      })
      .catch(error => {
        console.error('Bundle add error:', error);
        alert('Error adding bundle to cart. Please try again.');
        if (button) {
          button.disabled = false;
          button.textContent = originalText;
        }
      });
      
      return false;
    }
    
    // Handle single product - Direct add method
    window.location.href = `/cart/add?id=${variantId}&quantity=1&discount=${discountCode}&return_to=/cart`;
    
    return false;
  };
  
  // Legacy function support for backward compatibility
  window.addToCart = window.quizAddToCart;
  
  // Auto-initialize buttons with data attributes
  document.addEventListener('DOMContentLoaded', function() {
    // Find all quiz result buttons
    const buttons = document.querySelectorAll('[data-quiz-add-to-cart]');
    
    buttons.forEach(button => {
      button.addEventListener('click', function(e) {
        const productName = this.getAttribute('data-product-name');
        const isAlternative = this.hasAttribute('data-alternative');
        const variantId = this.getAttribute('data-variant-id') || productCatalog[productName];
        window.quizAddToCart(productName, variantId, isAlternative);
      });
    });
    
    // Track permalink view if applicable
    if (isPermalink() && typeof klaviyo !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      klaviyo.push(['track', 'Quiz Results Permalink Viewed', {
        'Quiz ID': urlParams.get('quiz_id'),
        'Result ID': urlParams.get('result_id') || urlParams.get('results'),
        'Concern': urlParams.get('concern')
      }]);
    }
  });
  
})();